import {
  FETCH_PARTNERS,
  FETCH_PARTNERS_SUCCESS,
  FETCH_PARTNERS_FAILED,
  EDIT_PARTNER,
  APPROVE_PARTNER,
  SET_CURRENT_PARTNER,
  FETCH_MY_PARTNER,
  FETCH_MY_PARTNER_SUCCESS,
  FETCH_MY_PARTNER_FAILED,
  STOP_FETCH_MY_PARTNER,
  UPDATE_MY_PARTNER,
  FETCH_PARTNER_INCOMING_SUCCESS,
  STOP_FETCH_PARTNER_INCOMING,
  DISMISS_PARTNER_INCOMING,
} from '../store/types';

const INITIAL_STATE = {
  partners: null,
  byId: {},
  current: null,
  // `myPartner`: el negocio del usuario logueado en la app de socio.
  // null = no cargado todavía. {} = no encontró negocio para este uid.
  myPartner: null,
  myPartnerLoading: false,
  // Pedidos PENDING activos del socio logueado, ordenados por createdAt asc.
  // El primero alimenta el modal PartnerIncomingOrder. `dismissed[oid]=true`
  // saca un order del foco (tras aceptar/rechazar/timeout) hasta que la DB
  // refleja el cambio de status y el subscribe lo retira.
  incomingOrders: [],
  dismissed: {},
  loading: false,
  error: { flag: false, msg: null },
};

const buildById = (list) => {
  if (!Array.isArray(list)) return {};
  const map = {};
  list.forEach((p) => {
    if (p && p.id) map[p.id] = p;
  });
  return map;
};

export const partnerreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PARTNERS:
      return { ...state, loading: true };
    case FETCH_PARTNERS_SUCCESS:
      return {
        ...state,
        partners: action.payload,
        byId: buildById(action.payload),
        loading: false,
        error: { flag: false, msg: null },
      };
    case FETCH_PARTNERS_FAILED:
      return {
        ...state,
        partners: null,
        byId: {},
        loading: false,
        error: { flag: true, msg: action.payload },
      };
    case SET_CURRENT_PARTNER:
      return { ...state, current: action.payload };
    case FETCH_MY_PARTNER:
      return { ...state, myPartnerLoading: true };
    case FETCH_MY_PARTNER_SUCCESS:
      // payload puede ser null si el usuario aún no creó negocio (cuenta nueva).
      return { ...state, myPartner: action.payload, myPartnerLoading: false };
    case FETCH_MY_PARTNER_FAILED:
      return { ...state, myPartner: null, myPartnerLoading: false };
    case STOP_FETCH_MY_PARTNER:
      return { ...state, myPartnerLoading: false };
    case UPDATE_MY_PARTNER:
      // Optimistic local merge mientras se confirma la escritura.
      return {
        ...state,
        myPartner: state.myPartner ? { ...state.myPartner, ...action.payload } : action.payload,
      };
    case FETCH_PARTNER_INCOMING_SUCCESS: {
      // payload: array de orders PENDING.
      const list = Array.isArray(action.payload) ? action.payload : [];
      // Auto-limpiar dismissed para orders que ya no están PENDING (la DB ya
      // los retiró), evita que se queden marcados eternamente.
      const stillPending = new Set(list.map((o) => o.id));
      const dismissed = {};
      Object.keys(state.dismissed || {}).forEach((k) => {
        if (stillPending.has(k)) dismissed[k] = true;
      });
      return { ...state, incomingOrders: list, dismissed };
    }
    case STOP_FETCH_PARTNER_INCOMING:
      return { ...state, incomingOrders: [], dismissed: {} };
    case DISMISS_PARTNER_INCOMING:
      return {
        ...state,
        dismissed: { ...(state.dismissed || {}), [action.payload]: true },
      };
    case EDIT_PARTNER:
    case APPROVE_PARTNER:
      return state;
    default:
      return state;
  }
};
